import { useContext, useEffect, useState } from "react";
import { StyleSheet, Text, TouchableWithoutFeedback, View } from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import IconButton from "../../components/ButtonIcon";
import PageTitle from "../../components/PageTitle";
import PaymentFormList from "../../components/PaymentsFormList";
import { GlobalContext } from "../../contexts/global";
import { PaymentContext } from "../../contexts/payment";
import GetCardType from "../../helpers/creditCard";

import {
  PaymentBill,
  PaymentContract as PaymentContractApi,
} from "../../services/Api/payment";

import { Encrypt } from "../../services/Crypt";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import ConfirmCvv from "../Wallet/components/ConfirmCvv";
import Ticket from "./components/Ticket";

export default function PaymentContract({ navigation, route }) {
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  const {
    selectedPaymentForm,
    newCard,
    validNewCard,
    saveCard,
    cardNumber,
    cardExpiration,
    cardBrand,
    cardName,
    saveCardApi,
    clearInput,
  } = useContext(PaymentContext);

  useEffect(() => clearInput(), []);

  const [modalVisible, setModalVisible] = useState(false);
  const data = route.params;
  
  const disabledButton =
    !!data.totalAmount && (!!selectedPaymentForm || newCard) ? false : true;

  const paymentContractApiHandler = (selectedCardData, cvv) => {
    setLoading({ show: true, message: "Realizando o pagamento" });

    if (data.idVacancy) {
      PaymentBill(
        data.totalAmount,
        selectedCardData.cardNumber ? Encrypt(selectedCardData.cardNumber.replace(/\s/g, "")) : null,
        cvv,
        selectedCardData.expiration,
        data.unityId,
        data.idVacancy,
        data.nossoNumero,
        selectedCardData.idCard,
        selectedCardData.payType
      )
        .then((value) => {
          navigation.reset({
            index: 0,
            routes: [{ name: "PaymentReceipt", params: value.data }],
          });
        })
        .catch((value) => {
          setShowAlert({
            type: "alert",
            title: "Oops",
            message: value.erro ? value.erro : value.message,
            show: true,
            confirmText: "OK",
            pressConfirm: () => {
              setShowAlert({ ...showAlert, show: false });
            },
            showConfirmButton: true,
          });
        })
        .finally(() => {
          clearInput()
          setLoading({ show: false, message: "Realizando o pagamento" });
        });
    } else {
      PaymentContractApi(
        data.totalAmount,
        selectedCardData.cardNumber ? Encrypt(selectedCardData.cardNumber.replace(/\s/g, "")) : null,
        cvv,
        selectedCardData.expiration,
        data.unityId,
        data.tablePrice.id,
        data.amountSpace,
        selectedCardData.idCard,
        selectedCardData.payType
      )
        .then((value) => {
          if (value.vacancy == null) {
            setShowAlert({
              type: "alert",
              title: "Não foi possível salvar o contrato",
              message:
                "O pagamento foi efetuado porem não foi possivel adicionar o contrato. Por favor contate a administração.",
              show: true,
              confirmText: "OK",
              pressConfirm: () => {
                setShowAlert({ ...showAlert, show: false });
              },
              showConfirmButton: true,
            });
          }
          navigation.reset({
            index: 0,
            routes: [{ name: "PaymentReceipt", params: value }],
          });
        })
        .catch((value) => {
          setShowAlert({
            type: "alert",
            title: "Oops",
            message: value.erro ? value.erro : value.message,
            show: true,
            confirmText: "OK",
            pressConfirm: () => {
              setShowAlert({ ...showAlert, show: false });
            },
            showConfirmButton: true,
          });
        })
        .finally(() => {
          clearInput()
          setLoading({ show: false, message: "Realizando o pagamento" });
        });
    }
  };

  return (
    <PageTitle title={"PAGAR MENSALIDADE"} navigation={navigation}>
      <KeyboardAwareScrollView
        style={{ flex: 1, backgroundColor: Colors.WHITE }}
        keyboardShouldPersistTaps={"always"}
      >
        {data.totalAmount != null ? (
          <View
            style={{ flex: 1, justifyContent: "flex-start", width: "100%" }}
          >
            <TouchableWithoutFeedback
              onPress={() => navigation.navigate("UnityDetails", data.unityId)}
            >
              <View
                style={{
                  alignItems: "center",
                  padding: 8,
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Icon size={32} name={"map-marker-outline"} />
                <Text style={{ fontSize: Fonts.FONT_SIZE_16, marginLeft: 4 }}>
                  {data.unityName}
                </Text>
              </View>
            </TouchableWithoutFeedback>
            <Ticket contractInfo={data} />
            <View style={styles.viewSecundaria}>
              <View style={styles.titleBar}>
                <Text style={styles.titleText}>{"FORMAS DE PAGAMENTOS"}</Text>
              </View>
              <PaymentFormList totalAmount={data.totalAmount} />
            </View>
            <IconButton
              textoBotao={"Realizar pagamento"}
              onPress={() => {
                if (newCard) {
                  if (validNewCard()) {
                    if (saveCard) {
                      let cardBrandType = GetCardType(cardNumber.replace(/\s/g, ""));
                        setLoading({ show: true, message: "Salvando cartão" })
                        saveCardApi(cardBrandType)
                    }
                  }
                }
                let payType = selectedPaymentForm.payType ?? 0;
                if (payType > 0)
                  setShowAlert({
                    type: "info",
                    title: "Atenção",
                    message: `Confirmar pagamento via ${
                      payType == 2
                        ? "carteira compartilhada"
                        : payType == 1
                        ? "carteira"
                        : "não informado"
                    }?`,
                    show: true,
                    cancelText: "Não",
                    confirmText: "Sim",
                    pressCancel: () => {
                      setShowAlert({ ...showAlert, show: false });
                    },
                    pressConfirm: () => {
                      paymentContractApiHandler(selectedPaymentForm, "");
                      setShowAlert({ ...showAlert, show: false });
                    },
                    showConfirmButton: true,
                  });
                else setModalVisible(true);

                setLoading({ show: false, message: "Salvando cartão" });
              }}
              iconName={"currency-usd"}
              estilo={{
                backgroundColor: disabledButton
                  ? Colors.GRAY_DARK
                  : Colors.SUCCESS,
                width: "100%",
                marginTop: 16,
              }}
              disabled={disabledButton}
            />
            <ConfirmCvv
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
              onPress={(cvv) =>
                paymentContractApiHandler(
                  newCard
                    ? {
                        brand: cardBrand,
                        expiration: cardExpiration,
                        cardNumber: cardNumber,
                        personName: cardName,
                        payType: 0,
                      }
                    : selectedPaymentForm,
                  cvv
                )
              }
              countCell={3}
            />
          </View>
        ) : (
          <></>
        )}
      </KeyboardAwareScrollView>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  titleText: {
    color: Colors.BLACK,
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "bold",
  },
  titleBar: {
    alignItems: "center",
    flexDirection: "row",
    padding: 12,
    justifyContent: "center",
  },
  viewSecundaria: {
    backgroundColor: Colors.WHITE,
    width: "100%",
    flex: 1,
    flexGrow: 1,
    padding: 4,
    justifyContent: "center",
    alignItems: "center",
  },
});
